/**
 * Production environment settings
 *
 * This file is where you define overrides for any of the config settings that
 * should only be applied in the production environment.
 *
 * The production environment is defined as 'process.env.NODE_ENV=production' and
 * is automatically set when webpack is invoked using the --env=production argument.
 **/

module.exports = {

  /**
   * To override a config setting, specify the name of the config file you
   * want to override, followed by the settings you want to change.
   */

  // actions: {
  //   normalize: true
  // },

  // connections: {
  //   default: {
  //     apiRoot: 'https://api.example.dev'
  //   }
  // }
  connections: {
    default: {
      apiRoot: process.env.API_ROOT
    }
  }
};



// WEBPACK FOOTER //
// ./config/env/production.js